export default __webpack_public_path__ + "static/media/Box.def13ded.png";